import $ from "jquery";
import moment from "moment";
import { dataaccess } from "../dataaccess/dataContext";
import { forms } from "../framework/forms";

let data;
let params;

function init() {
    $("#add-role-window").click(function() {
        $("#add-person-roles").prop("disabled", true);
        $("#role-submit").prop("disabled", true);
        dataaccess
            .get({ url: "/Person/GetAvailableRoles/" + $("#personId").val() })
            .done(function(results) {
                $("#add-person-roles option").remove();
                if (results.length > 0) {
                    let i;
                    for (i = 0; i < results.length; i++) {
                        $("#add-person-roles").append(
                            "<option value=" + results[i].id + ">" + results[i].name + "</option>"
                        );
                    }
                    $("#add-person-roles").prop("disabled", false);
                    $("#role-submit").prop("disabled", false);
                }
            });
    });

    $("#role-submit").click(function() {
        $(this).prop("disabled", true);
        if ($("#add-person-roles").val() === undefined) {
            $("#role-text-val").css("visibility", "visible");
        } else {
            data = {
                roleId: $("#add-person-roles").val(),
                personId: $("#role-personId").val()
            };

            params = {
                data: data,
                url: "/Person/AddRole"
            };

            forms.showSpinner("Saving...", false);

            dataaccess
                .post(params)
                .done(function() {
                    location.reload();
                    forms.showSpinner("Saving...", false);
                    $(this).prop("disabled", false);
                })
                .fail(function() {
                    $(this).prop("disabled", false);
                    forms.hideSpinner();
                }).always(function() {
                });
        }
    });

    $(".js-role-edit").click(function() {
        const $row = $(this).closest("div");
        $row.find("button, .js-role-dates").toggle();
    });

    $(".js-role-cancel").click(function() {
        const $row = $(this).closest("div");
        $row.find("button, .js-role-dates").toggle();
    });

    $(".js-role-delete").click(function() {
        if (window.confirm("Are you sure you want to delete this person's role?")) {
            const personRoleId = $(this).data("id");
            forms.showSpinner("Deleting...", false);
            dataaccess.delete({ url: "/personrole/" + personRoleId }).done(function() {
                location.reload();
                forms.showSpinner("Deleting...", false);
            }).fail(function() {
                forms.hideSpinner();
            });
        }
    });

    $(".js-role-save").click(function() {
        const personRoleId = $(this).data("id");
        const $row = $(this).closest("div");
        const startDate = $row.find(".js-start-date").val();
        const endDate = $row.find(".js-end-date").val();

        if (startDate === "") {
            $row.find(".field-validation-error").show();
            return;
        } else {
            $row.find(".field-validation-error").hide();
        }

        const parameters = {
            data: {
                startDateUtc: startDate,
                endDateUtc: endDate
            },
            url: "/personrole/" + personRoleId
        };

        dataaccess.put(parameters).done(function(result) {
            const endDate =
                result.endDateUtc === null
                    ? "Present"
                    : moment(new Date(result.endDateUtc)).format("MMM. YYYY");
            const displayDates = moment(new Date(result.startDateUtc)).format("MMM. YYYY") + " - " + endDate;
            $row
                .find(".js-role-dates")
                .first()
                .text(displayDates);
            $row.find("button, .js-role-dates").toggle();
        });
    });

    $("#display-role-modal").on("hide.bs.modal", function() {
        location.reload();
    });
    $("#js-role-reverify").click(function() {
        const personid = $("#personId").val();
        const parameters = {
            url: "/person/reverify/" + personid + "/Yes"
        };
        dataaccess.post(parameters).done(function(results) {
            let alertMessage = "";
            let i;
            for (i = 0; i < results.length; i++) {
                alertMessage = alertMessage + results[i] + "\n";
            };
            alert(alertMessage);
            location.reload();
        });
    });
}

export const addRole = {
    init: init
};
